import { ApiParameter, get, patch, post, request } from "@insite/client-framework/Services/ApiService";
import { BaseModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

export interface BillToModelCollection {
    uri: any;
    pagination: Pagination;
    billTos: BillTo[];
    properties: Properties4;
}

export interface GetBillingParams {
    expand?: string;
    page?: string;
    pageSize?: string;
    filter?: string;
    getBillingChild: boolean;
}

export interface Pagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: any;
    sortType: any;
    nextPageUri: any;
    prevPageUri: any;
}

export interface BillTo {
    uri: string;
    erpBillToNumber: string;
    customerType: string;
    shipTosUri: string;
    isGuest: boolean;
    label: string;
    budgetEnforcementLevel: string;
    costCodeTitle: string;
    customerCurrencySymbol: string;
    costCodes: any;
    shipTos: ShipToModel[];
    validation: Validation;
    isDefault: boolean;
    accountsReceivable: any;
    id: string;
    customerNumber: string;
    customerSequence: string;
    customerName: string;
    firstName: string;
    lastName: string;
    contactFullName: string;
    companyName: string;
    attention: string;
    address1: string;
    address2: string;
    address3: string;
    address4: string;
    city: string;
    postalCode: string;
    state: State2;
    country: Country2;
    phone: string;
    fullAddress: string;
    email: string;
    fax: string;
    isVmiLocation: boolean;
    properties: Properties3;
}

export interface Validation {
    firstName: FirstName;
    lastName: LastName;
    companyName: CompanyName;
    attention: Attention;
    address1: Address1;
    address2: Address2;
    address3: Address3;
    address4: Address4;
    country: Country;
    state: State;
    city: City;
    postalCode: PostalCode;
    phone: Phone;
    email: Email;
    fax: Fax;
}

export interface FirstName {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface LastName {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface CompanyName {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface Attention {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface Address1 {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface Address2 {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface Address3 {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface Address4 {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface Country {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: any;
}

export interface State {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: any;
}

export interface City {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface PostalCode {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface Phone {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface Email {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface Fax {
    isRequired: boolean;
    isDisabled: boolean;
    maxLength: number;
}

export interface State2 {
    uri: string;
    id: string;
    name: string;
    abbreviation: string;
    properties: Properties;
}

export interface Properties {}

export interface Country2 {
    uri: string;
    id: string;
    name: string;
    abbreviation: string;
    states: any[];
    properties: Properties2;
}

export interface Properties2 {}

export interface Properties3 {
    p21ContactID: string;
    freeshipThresholdAmt: string;
    defaultAdminDC:string; // added this variable ---P21 change
}

export interface Properties4 {
    currentCustomerNumber: string;
    currentBillToCustomerNumber: string;
    currentCustomerFreeshipThresholdAmt: string;
}

const billToUrl = "/api/v2/getacountbillto";

export async function getBillToDetails(parameter: GetBillingParams) {
    const response = await get<BillToModelCollection>(
        `${billToUrl}?expand=${parameter.expand}&filter=${parameter.filter}&page=${parameter.page}&pageSize=${parameter.pageSize}`,
    );
    return response;
}
